import { Injectable, EventEmitter } from '@angular/core';
import { ModalComponent } from './modal.component';

@Injectable()
export class ModalService {

  private modals: ModalComponent[];

  constructor() {
    this.modals = [];
  }

  registerModal(newModal: ModalComponent): void {
    let modal = this.modals.find(m => m.modalId === newModal.modalId);
    if (modal) {
      this.modals.splice(this.modals.indexOf(modal), 1);
    }
    this.modals.push(newModal);
  }

  open(modalId: string): void {
    let modal = this.modals.find(m => m.modalId === modalId);
    if (modal) {
      modal.isOpen = true;
      modal.fadeIn();
    }
  }

  close(modalId: string): void {
    let modal = this.modals.find(m => m.modalId === modalId);
    if (modal && modal.isOpen) {
      modal.isOpen = false;
      modal.fadeOut();
    }
  }

  subscribeToShown(modalId): EventEmitter<boolean> {
    let modal = this.modals.find(m => m.modalId === modalId);
    if (modal) {
      return modal.onShown;
    }
    return null;
  }

  subscribeToHidden(modalId): EventEmitter<boolean> {
    let modal = this.modals.find(m => m.modalId === modalId);
    if (modal) {
      return modal.onHidden;
    }
    return null;
  }
}
